import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { DsLibMainMenuTab } from '../../models/ds-lib-main-menu-tab.model';
import { FormControl } from '@angular/forms';
import { DsLibSearchAutocompleteComponent } from '@sixense/ds-lib-common';

@Component({
  selector: 'ds-lib-dropdown-list',
  templateUrl: './ds-lib-dropdown-list.component.html',
  styleUrls: ['./ds-lib-dropdown-list.component.scss'],
})
export class DsLibDropdownListComponent {
  /**
   * Is the menu expanded
   */
  @Input() isExpanded: boolean;

  /**
   * A menu tab instance of the `DsLibMainMenuTab`.
   *
   * @param tab DsLibMainMenuTab
   */
  @Input() set tab(tab: DsLibMainMenuTab) {
    this._tab = tab;
    if (tab.selectedItem) {
      this.selectedControl.setValue(tab.selectedItem);
    }
  }

  /** Event emitted when an item is selected inside a select dropdown */
  @Output() selectItemClick = new EventEmitter();

  /** Event emitted when we clicked on the dropdown icon */
  @Output() dropdownIconClick = new EventEmitter();

  /**
   *
   */
  @ViewChild(DsLibSearchAutocompleteComponent)
  public autocompleteComponent: DsLibSearchAutocompleteComponent;

  /** FromControl to keep value of the selected item in the dropdown */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public selectedControl: any = new FormControl({});

  /**
   * Whether the list selection is opened (mat-select)
   */
  public opened = false;

  /**
   * Current menu tab
   */
  public _tab: DsLibMainMenuTab;

  /**
   * Event emitted when clicked on an option of the dropdown.
   *
   * @param tab tab to send to the parent
   * @param item selected item to send to the parent
   */
  public selectChange() {
    this.selectItemClick.emit({ tab: this._tab, item: this.selectedControl.value });
  }

  /**
   * On project section clicked, expand the menu.
   */
  public onDropdownIconClicked() {
    this.dropdownIconClick.emit();
    setTimeout(() => {
      this.autocompleteComponent.openMatselect();
    }, 5);
  }
}
